
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `برای تجربه گسترده و دسترسی آسان آن را به صفحه اصلی خود اضافه کنید.`,
's224cbcec014ef6b5': `در نوار پایین دکمه (Share) را  بزنید`,
's37a9e8aec5713460': `بیشتر`,
's386eca8362ff6155': `اگر آیکون اشتراک‌گذاری وجود ندارد، روی بیشتر فشار دهید`,
's4e1e10a6ca408245': `روی "Add to Home screen" ضربه بزنید`,
's6196153c4b0c1ea0': `نصب`,
's633502f7cff4f847': `مرورگر خود را باز کنید`,
's681e399d63311fba': `نمایش گالری`,
's7f0591f08e318eda': `در منوی اشتراک‌گذاری روی بیشتر فشار دهید`,
's8114bd55cae5a22b': `(Add to Dock) را انتخاب کنید `,
's922329d6f6213590': `افزودن به (Dock)`,
's9af56bf005b49c74': `به پایین اسکرول کنید تا به "Add to Home Screen" برسید`,
'sa5ef80b4bb9b39f8': `کمتر`,
'sba52286c21552a4e': `برای تجربه گسترده و دسترسی آسان آن را بر روی دستگاه خود نصب کنید.`,
'sc16e00a7a8b2fde2': `بازگشت`,
'scdaf4bbff76674c8': `افزودن به (Home Screen)`,
'se0e473adfda8066c': `در مرورگر اصلی خود باز کنید`,
'se740f75b95a51807': `برای تجربه گسترده و دسترسی آسان آن را به Dock خود اضافه کنید.`,
'sfea652f6580ff086': ` این سایت دارای قابلیت اپلیکیشن است. `,
    };
  